/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  Conversation,
  ConversationMessage,
  ConversationMessageCreate,
  GetConversationsParams,
  MessageFeedback,
  PivotTable,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ConversationsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags conversations-controller
   * @name GetConversationMessages
   * @request GET:/api/v1/copilot/conversations/{conversationId}/messages
   */
  getConversationMessages = (conversationId: string, params: RequestParams = {}) =>
    this.http.request<ConversationMessage[], any>({
      path: `/v1/copilot/conversations/${conversationId}/messages`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getConversationMessagesPath = '/v1/copilot/conversations/${conversationId}/messages'
  static getConversationMessagesMethod = 'GET'
  /**
   * No description
   *
   * @tags conversations-controller
   * @name PostMessage
   * @request POST:/api/v1/copilot/conversations/{conversationId}/messages
   */
  postMessage = (
    conversationId: string,
    data: ConversationMessageCreate,
    params: RequestParams = {},
  ) =>
    this.http.request<ConversationMessage, any>({
      path: `/v1/copilot/conversations/${conversationId}/messages`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static postMessagePath = '/v1/copilot/conversations/${conversationId}/messages'
  static postMessageMethod = 'POST'
  /**
   * No description
   *
   * @tags conversations-controller
   * @name PostFeedback
   * @request POST:/api/v1/copilot/conversations/{conversationId}/messages/{messageId}/feedback
   */
  postFeedback = (
    conversationId: string,
    messageId: string,
    data: MessageFeedback,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/copilot/conversations/${conversationId}/messages/${messageId}/feedback`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static postFeedbackPath =
    '/v1/copilot/conversations/${conversationId}/messages/${messageId}/feedback'
  static postFeedbackMethod = 'POST'
  /**
   * No description
   *
   * @tags conversations-controller
   * @name StartConversation
   * @request POST:/api/v1/copilot/conversations/new/messages
   */
  startConversation = (data: ConversationMessageCreate, params: RequestParams = {}) =>
    this.http.request<ConversationMessage, any>({
      path: `/v1/copilot/conversations/new/messages`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static startConversationPath = '/v1/copilot/conversations/new/messages'
  static startConversationMethod = 'POST'
  /**
   * No description
   *
   * @tags conversations-controller
   * @name GetConversations
   * @request GET:/api/v1/copilot/conversations
   */
  getConversations = (query: GetConversationsParams, params: RequestParams = {}) =>
    this.http.request<Conversation[], any>({
      path: `/v1/copilot/conversations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getConversationsPath = '/v1/copilot/conversations'
  static getConversationsMethod = 'GET'
  /**
   * No description
   *
   * @tags conversations-controller
   * @name DownloadMessageRawTableCvs
   * @request GET:/api/v1/copilot/conversations/{conversationId}/messages/{messageId}/raw-data/csv
   */
  downloadMessageRawTableCvs = (
    conversationId: string,
    messageId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/copilot/conversations/${conversationId}/messages/${messageId}/raw-data/csv`,
      method: 'GET',
      ...params,
    })

  static downloadMessageRawTableCvsPath =
    '/v1/copilot/conversations/${conversationId}/messages/${messageId}/raw-data/csv'
  static downloadMessageRawTableCvsMethod = 'GET'
  /**
   * No description
   *
   * @tags conversations-controller
   * @name GetMessagePivotTable
   * @request GET:/api/v1/copilot/conversations/{conversationId}/messages/{messageId}/pivot-table
   */
  getMessagePivotTable = (conversationId: string, messageId: string, params: RequestParams = {}) =>
    this.http.request<PivotTable, any>({
      path: `/v1/copilot/conversations/${conversationId}/messages/${messageId}/pivot-table`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMessagePivotTablePath =
    '/v1/copilot/conversations/${conversationId}/messages/${messageId}/pivot-table'
  static getMessagePivotTableMethod = 'GET'
}
